import { useEffect, useState } from 'react';
import '../assets/css/modal.css';
import seleccionador from '../assets/img/gif/_seleccionador.gif'
import progress from '../assets/img/gif/progres.gif'

    const body = document.getElementById("container");



function Modal(props) {
    function close() {
        
        document.getElementById("modal").classList.toggle("view-modal")
        document.getElementById("modal").classList.add("view-modal-no")
    }
    function moneda(number) {
        const formattedNumber = number.toLocaleString('es-MX', {
            style: 'currency',
            currency: 'MXN',
            minimumFractionDigits: 2,
        });

        return formattedNumber;
    }
    useEffect(() => {

    });
    return (
        <div class="mdl view-modal-no" id="modal">
            <div class="mdl-content">
                <div class="mdl-button">
                    <i class="fas fa-times-circle" onClick={close}></i>
                </div>
                <div class="mdl-header">
                    {props.titulo}

                </div>
                <div class="mdl-body">
                    <div class="mdl-body body-content">
                        <div class="precio">
                            {moneda(props.precio)} - {props.puntos + "pts."}
                        </div>
                        <div class="descripcion">
                            {props.descripcion}
                        </div>
                        <div class="img">
                            <img src={"data:image/png;base64," + props.foto}></img>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Modal;